module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"dialog\" title=\"Import\" style=\"overflow-x: hidden; \">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-3\"><label>Select the file</label></div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-3\"><input type=\"button\" name=\"importFile\" value=\"Browse...\"></div>\r\n        <div class=\"col-md-3\"><input type=\"file\" name=\"file\" accept=\".csv,.txt,text/plain,text/csv\" class=\"hide\"></div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <span class=\"error_message hide\"></span>\r\n        </div>\r\n    </div>\r\n    <br />\r\n    <div class=\"row\">\r\n        <div class=\"col-md-3\"><label>Enter a name:</label></div>\r\n    </div>\r\n    <div>\r\n        <div class=\"col-md-9\"><input type=\"text\" name=\"name\"></div>\r\n    </div>\r\n</div>")
  }
  return __output;

}